// extracted by mini-css-extract-plugin
export default {"title":"styles_title__mfYdd","footer":"styles_footer__-J-NA"};